<template>
  <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
         _/                                                                                                                    _/
         _/      子画面定義：絞り込み条件画面(STFMFM02C02)                                                                     _/
         _/                                                                                                                    _/
         _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
  <div
    class="overlay"
    :class="[isShow ? showClass : hideClass]"
    id="popup-upload"
    data-role="popup-close"
    data-popup-width="1160"
    v-if="isShow"
  >
    <div class="popup search" style="width: 1160px" >
      <div class="popup-head">絞り込み条件</div>
      <div class="popup-body blue">
        <!--
          ****  メッセージ表示領域 ****
          -->
        <p class="errMsg title-ico ico-warning" v-show="errors != ''">
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
        <p
          :style="{ 'margin-top': errors.length > 0 ? '20px' : '' }"
          ref="refTitle"
        ></p>
        <div class="scroll" ref="refScrollDiv">
          <div class="mt-20px">
            <div
              class="frm-row"
              v-if="filterViewsDisplay.DisplayFlags?.searchTaget"
            >
              <span class="frm-label w-135px" @click="initFocus">{{
                filterViewsDisplay.DisplayItems.searchTaget
              }}</span>
              <select
                tabindex="1"
                class="frm-select frm-size-l"
                v-model.trim="searchConditionInfo.searchTaget"
                ref="refSearchTarget"
              >
                <option
                  v-for="item in searchTargetCodeList"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
          <div
            class="mt-20px"
            :class="[
              filterViewsDisplay.DisplayFlags?.searchTaget ? 'br-top' : '',
            ]"
          >
            <div class="frm-row">
              <span class="frm-label w-135px">検索キーワード</span>
              <div
                class="frm-search has-ico frm-size-full none-border-left ml-10px"
              >
                <input
                  tabindex="2"
                  type="search"
                  id="search"
                  class="frm-search-text"
                  placeholder="検索キーワード"
                  ref="refSearchKeyWord"
                  name="searchBox"
                  v-model.trim="searchConditionInfo.keyWord"
                  maxlength="255"
                />
              </div>
            </div>
            <div
              class="frm-row"
              v-if="filterViewsDisplay.DisplayFlags.dealinginfoInputStatus"
            >
              <span class="frm-label w-135px">{{
                filterViewsDisplay.DisplayItems.dealinginfoInputStatus
              }}</span>
              <select
                tabindex="3"
                class="frm-select frm-size-l"
                v-model.trim="searchConditionInfo.dealinginfoInputStatus"
              >
                <option
                  v-for="item in dealinginfoInputStatusCodeList"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div
              class="frm-row"
              v-if="filterViewsDisplay.DisplayFlags.fileName"
            >
              <span class="frm-label w-135px">{{
                filterViewsDisplay.DisplayItems.fileName
              }}</span>
              <select
                tabindex="4"
                class="frm-select frm-size-l"
                v-model.trim="searchConditionInfo.fileName"
                @change="handleFileNameChange"
              >
                <option
                  v-for="item in fileNameCodeList"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </option>
              </select>
              <input
                tabindex="5"
                type="text"
                class="frm-text frm-size-full"
                maxlength="255"
                v-model.trim="searchConditionInfo.fileNameInput"
                :disabled="isFileNameInputDisabled"
                :class="{ error: errorInfo.errorFileNameInput != '' }"
              />
            </div>
            <p
              class="errMsg ml-l45px"
              v-show="errorInfo.errorFileNameInput != ''"
            >
              <ErrorMessageCase
                :errors="errorInfo.errorFileNameInput"
              ></ErrorMessageCase>
            </p>
            <!-- No4:スキャナ保存対応 書類ID start　-->
            <div class="frm-row" v-if="filterViewsDisplay.DisplayFlags.paperID">
              <span class="frm-label w-135px">{{
                filterViewsDisplay.DisplayItems.paperID
              }}</span>
              <!-- No4:スキャナ保存対応 tabindex変更 -->
              <select
                tabindex="6"
                class="frm-select frm-size-l"
                v-model.trim="searchConditionInfo.paperID"
                @change="handlePaperIdChange"
              >
                <option
                  v-for="item in paperIdCodeList"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </option>
              </select>
              <!-- No4:スキャナ保存対応 tabindex変更 -->
              <input
                tabindex="7"
                type="text"
                class="frm-text frm-size-full"
                maxlength="255"
                v-model.trim="searchConditionInfo.paperIdInput"
                :disabled="isPaperIdInputDisabled"
                :class="{ error: errorInfo.errorPaperIdInput != '' }"
              />
            </div>
            <p
              class="errMsg ml-l45px"
              v-show="errorInfo.errorPaperIdInput != ''"
            >
              <ErrorMessageCase
                :errors="errorInfo.errorPaperIdInput"
              ></ErrorMessageCase>
            </p>
            <!-- No4:スキャナ保存対応 書類ID end-->
            <div
              class="frm-row"
              v-if="filterViewsDisplay.DisplayFlags.paperType"
            >
              <span class="frm-label w-135px">{{
                filterViewsDisplay.DisplayItems.paperType
              }}</span>
              <!-- No4:スキャナ保存対応 tabindex変更 -->
              <select
                tabindex="8"
                class="frm-select frm-size-l"
                v-model.trim="searchConditionInfo.paperType"
                @change="handlePaperTypeChange"
              >
                <option
                  v-for="item in paperTypeCodeList"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </option>
              </select>
              <!-- No4:スキャナ保存対応 tabindex変更 -->
              <input
                tabindex="9"
                type="text"
                class="frm-text frm-size-full"
                maxlength="10"
                v-model.trim="searchConditionInfo.paperTypeInput"
                :disabled="isPaperTypeInputDisabled"
                :class="{ error: errorInfo.errorPaperTypeInput != '' }"
              />
            </div>
            <p
              class="errMsg ml-l45px"
              v-show="errorInfo.errorPaperTypeInput != ''"
            >
              <ErrorMessageCase
                :errors="errorInfo.errorPaperTypeInput"
              ></ErrorMessageCase>
            </p>
            <div
              class="frm-row"
              v-if="filterViewsDisplay.DisplayFlags.issueDate"
            >
              <span class="frm-label w-135px">{{
                filterViewsDisplay.DisplayItems.issueDate
              }}</span>
              <!-- No4:スキャナ保存対応 tabindex変更 -->
              <select
                tabindex="10"
                class="frm-select frm-size-l"
                v-model.trim="searchConditionInfo.issueDate"
                @change="handleIssueDateChange"
              >
                <option
                  v-for="item in issueDateCodeList"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </option>
              </select>
              <!-- No7日付のカレンダー入力対応 start-->
              <DateCalandar
                :disabled="isIssueDateYearFromInputDisabled"
                :isMonthType="searchConditionInfo.issueDate == '4'"
                :errorInfo="{
                  isIssueDateError: errorInfo.errorIssueDate != '',
                }"
                :wareki="{
                  issueDateNengo: searchConditionInfo.issueDateGengoFromInput
                    ? yearList[searchConditionInfo.issueDateGengoFromInput].name
                    : '',
                  issueDateWarekiYear:
                    searchConditionInfo.issueDateYearFromInput,
                  issueDateWarekiMonth:
                    searchConditionInfo.issueDateMonthFromInput,
                  issueDateWarekiDay: searchConditionInfo.issueDateDayFromInput,
                }"
                @handleDateChange="
                  (wareki) => {
                    handleDateChange(wareki, searchConditionInfo, [
                      `issueDateGengoFromInput`,
                      `issueDateYearFromInput`,
                      `issueDateMonthFromInput`,
                      `issueDateDayFromInput`,
                    ]);
                  }
                "
              ></DateCalandar>

              <!-- <select 
                tabindex="9"
                class="frm-select frm-size-70px" 
                v-model.trim="searchConditionInfo.issueDateGengoFromInput"
                :disabled="isissueDateGengoFromSelcetDisabled"
                @change="handleIssueDateGengoFromChange"
              >
                <option
                  v-for="item in yearList"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </option>
              </select>
              <input 
                tabindex="10"
                title=" "
                type="url"
                maxlength="2"
                class="frm-text frm-size-xs alignright" 
                :disabled="isIssueDateYearFromInputDisabled"
                v-model.trim="searchConditionInfo.issueDateYearFromInput"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                :class="{error: errorInfo.errorIssueDate!=''}"
              >
              <span class="frm-unit">年</span>
              <input 
                tabindex="11"
                title=" "
                type="url"
                maxlength="2"
                class="frm-text frm-size-xs alignright ml-5px" 
                :disabled="isIssueDateMonthFromInputDisabled"
                v-model.trim="searchConditionInfo.issueDateMonthFromInput"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                :class="{error: errorInfo.errorIssueDate!=''}"
              >
              <span class="frm-unit">月</span>
              <input 
                tabindex="12"
                title=" "
                type="url"
                maxlength="2"
                class="frm-text frm-size-xs alignright ml-5px" 
                :disabled="isIssueDateDayFromInputDisabled"
                v-model.trim="searchConditionInfo.issueDateDayFromInput"
                v-show="isShowIssueDateDayFromInput"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                :class="{error: errorInfo.errorIssueDate!=''}"
              >
              <span class="frm-unit" v-show="isShowIssueDateDayFromInput"
                >日</span
              > -->
              <!-- No7日付のカレンダー入力対応 end-->
              <span class="frm-unit" v-show="isShowissueDateGengoToInput"
                >～</span
              >
              <!-- No7日付のカレンダー入力対応 start-->
              <DateCalandar
                v-show="isShowissueDateGengoToInput"
                :errorInfo="{
                  isIssueDateError: errorInfo.errorIssueDate != '',
                }"
                :wareki="{
                  issueDateNengo: searchConditionInfo.issueDateGengoToInput
                    ? yearList[searchConditionInfo.issueDateGengoToInput].name
                    : '',
                  issueDateWarekiYear: searchConditionInfo.issueDateYearToInput,
                  issueDateWarekiMonth:
                    searchConditionInfo.issueDateMonthToInput,
                  issueDateWarekiDay: searchConditionInfo.issueDateDayToInput,
                }"
                @handleDateChange="
                  (wareki) => {
                    handleDateChange(wareki, searchConditionInfo, [
                      `issueDateGengoToInput`,
                      `issueDateYearToInput`,
                      `issueDateMonthToInput`,
                      `issueDateDayToInput`,
                    ]);
                  }
                "
              ></DateCalandar>
              <!-- <select
                tabindex="13"
                class="frm-select frm-size-70px"
                v-model.trim="searchConditionInfo.issueDateGengoToInput"
                v-show="isShowissueDateGengoToInput"
                @change="handleIssueDateGengToChange"
              >
                <option
                  v-for="item in yearList"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </option>
              </select>
              <input
                tabindex="14"
                title=" "
                type="url"
                maxlength="2"
                class="frm-text frm-size-xs alignright"
                v-model.trim="searchConditionInfo.issueDateYearToInput"
                :class="{error: errorInfo.errorIssueDate!=''}"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                v-show="isShowissueDateGengoToInput"
              />
              <span class="frm-unit" v-show="isShowissueDateGengoToInput">年</span>
              <input
                tabindex="15"
                title=" "
                type="url"
                maxlength="2"
                class="frm-text frm-size-xs ml-5px alignright"
                v-model.trim="searchConditionInfo.issueDateMonthToInput"
                :class="{error: errorInfo.errorIssueDate!=''}"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                v-show="isShowissueDateGengoToInput"
              />
              <span class="frm-unit" v-show="isShowissueDateGengoToInput">月</span>
              <input
                tabindex="16"
                title=" "
                type="url"
                maxlength="2"
                class="frm-text frm-size-xs ml-5px alignright"
                v-model.trim="searchConditionInfo.issueDateDayToInput"
                v-show="isShowissueDateGengoToInput"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                :class="{error: errorInfo.errorIssueDate!=''}"
              />
              <span class="frm-unit" v-show="isShowissueDateGengoToInput"
              >日</span> -->
              <!-- No7日付のカレンダー入力対応 end-->
            </div>
            <p class="errMsg ml-l45px" v-show="errorInfo.errorIssueDate != ''">
              <ErrorMessageCase
                :errors="errorInfo.errorIssueDate"
              ></ErrorMessageCase>
            </p>
            <div class="frm-row" v-if="filterViewsDisplay.DisplayFlags.company">
              <span class="frm-label w-135px">{{
                filterViewsDisplay.DisplayItems.company
              }}</span>
              <!-- No4:スキャナ保存対応 tabindex変更 -->
              <select
                tabindex="11"
                class="frm-select frm-size-l"
                v-model.trim="searchConditionInfo.company"
                @change="handleCompanyChange"
              >
                <option
                  v-for="item in companyCodeList"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </option>
              </select>
              <!-- No4:スキャナ保存対応 tabindex変更 -->
              <input
                tabindex="12"
                type="text"
                class="frm-text frm-size-full"
                maxlength="52"
                v-model.trim="searchConditionInfo.companyInput"
                :disabled="isCompanyInputDisabled"
                :class="{ error: errorInfo.errorCompanyInput != '' }"
              />
            </div>
            <p
              class="errMsg ml-l45px"
              v-show="errorInfo.errorCompanyInput != ''"
            >
              <ErrorMessageCase
                :errors="errorInfo.errorCompanyInput"
              ></ErrorMessageCase>
            </p>
            <div class="frm-row" v-if="filterViewsDisplay.DisplayFlags.amount">
              <span class="frm-label w-135px">{{
                filterViewsDisplay.DisplayItems.amount
              }}</span>
              <!-- No4:スキャナ保存対応 tabindex変更 -->
              <select
                tabindex="13"
                class="frm-select frm-size-l"
                v-model.trim="searchConditionInfo.amount"
                @change="handleAmountChange"
              >
                <option
                  v-for="item in amountCodeList"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </option>
              </select>
              <!-- No4:スキャナ保存対応 tabindex変更 -->
              <input
                tabindex="14"
                type="text"
                class="frm-text w-160px alignright"
                maxlength="15"
                :onkeypress="
                  (e) =>
                    this.amountOnKeyPress(
                      e,
                      this.$refs.refAmountFromInput,
                      this.searchConditionInfo.amountFromInput
                    )
                "
                v-model.trim="searchConditionInfo.amountFromInput"
                :disabled="isAmountFromInputDisabled"
                :class="{ error: errorInfo.errorAmount != '' }"
                ref="refAmountFromInput"
                v-on:focusin="amountFromInputFocusin"
                v-on:focusout="amountFromInputFocusOut"
              />
              <span class="frm-unit">円</span>
              <span class="frm-unit" v-show="isShowAmountToInput">～</span>
              <!-- No4:スキャナ保存対応 tabindex変更 -->
              <input
                tabindex="15"
                type="url"
                title=" "
                class="frm-text w-160px alignright"
                maxlength="15"
                :onkeypress="
                  (e) =>
                    this.amountOnKeyPress(
                      e,
                      this.$refs.refAmountToInput,
                      this.searchConditionInfo.amountToInput
                    )
                "
                v-model.trim="searchConditionInfo.amountToInput"
                :class="{ error: errorInfo.errorAmount != '' }"
                v-show="isShowAmountToInput"
                ref="refAmountToInput"
                v-on:focusin="amountToInputFocusin"
                v-on:focusout="amountToInputFocusOut"
              />
              <span class="frm-unit" v-show="isShowAmountToInput">円</span>
            </div>
            <p class="errMsg ml-l45px" v-show="errorInfo.errorAmount != ''">
              <ErrorMessageCase
                :errors="errorInfo.errorAmount"
              ></ErrorMessageCase>
            </p>
            <div class="frm-row" v-if="filterViewsDisplay.DisplayFlags.remarks">
              <span class="frm-label w-135px">{{
                filterViewsDisplay.DisplayItems.remarks
              }}</span>
              <!-- No4:スキャナ保存対応 tabindex変更 -->
              <select
                tabindex="16"
                class="frm-select frm-size-l"
                v-model.trim="searchConditionInfo.remarks"
                @change="handleRemarksChange"
              >
                <option
                  v-for="item in remarksCodeList"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </option>
              </select>
              <!-- No4:スキャナ保存対応 tabindex変更 -->
              <input
                tabindex="17"
                type="text"
                class="frm-text frm-size-full"
                maxlength="200"
                v-model.trim="searchConditionInfo.remarksInput"
                :disabled="isRemarksInputDisabled"
                :class="{ error: errorInfo.errorRemarksInput != '' }"
              />
            </div>
            <p
              class="errMsg ml-l45px"
              v-show="errorInfo.errorRemarksInput != ''"
            >
              <ErrorMessageCase
                :errors="errorInfo.errorRemarksInput"
              ></ErrorMessageCase>
            </p>
            <div class="frm-row" v-if="filterViewsDisplay.DisplayFlags.updater">
              <span class="frm-label w-135px">{{
                filterViewsDisplay.DisplayItems.updater
              }}</span>
              <!-- No4:スキャナ保存対応 tabindex変更 -->
              <select
                tabindex="18"
                class="frm-select frm-size-l"
                v-model.trim="searchConditionInfo.updater"
                @change="handleUpdaterChange"
              >
                <option
                  v-for="item in updaterCodeList"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </option>
              </select>
              <!-- No4:スキャナ保存対応 tabindex変更 -->
              <input
                tabindex="19"
                type="text"
                class="frm-text frm-size-full"
                maxlength="50"
                v-model.trim="searchConditionInfo.updaterInput"
                :disabled="isUpdaterInputDisabled"
                :class="{ error: errorInfo.errorUpdaterInput != '' }"
              />
            </div>
            <p class="errMsg ml-l45px">
              <ErrorMessageCase
                :errors="errorInfo.errorUpdaterInput"
              ></ErrorMessageCase>
            </p>
          </div>
        </div>
      </div>
      <div class="popup-foot blue">
        <div class="footer-btn">
          <div class="frm-btn-row">
            <div class="frm-item grow center">
              <!-- No4:スキャナ保存対応 tabindex変更 -->
              <button
                tabindex="20"
                class="frm-btn strong large"
                data-role="popup-close"
                data-target="#popup-process"
                ref="searchButton"
                :disabled="isProcessing"
                @click="SearchBtn"
              >
                検索
              </button>
              <!-- No4:スキャナ保存対応 tabindex変更 -->
              <button
                tabindex="21"
                class="frm-btn large"
                data-role="popup-close"
                :disabled="isProcessing"
                @click="CancelBtn"
                @blur="onblur"
              >
                キャンセル
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import Common from "@/util/common";
import moment from "moment";
import {
  FILTER_VIEWS_DISPLAY_FLAG_LIST,
  SEARCH_TARGET_CODE_LIST,
  DEALINGINFO_INPUT_STATUS_CODE_LIST,
  FILE_NAME_CODE_LIST,
  PAPER_ID_CODE_LIST, // No4:スキャナ保存対応 書類ID
  PAPER_TYPE_CODE_LIST,
  ISSUE_DATE_CODE_LIST,
  COMPANY_CODE_LIST,
  AMOUNT_CODE_LIST,
  REMARKS_CODE_LIST,
  UPDATER_CODE_LIST,
  YEAR_LIST,
  SearchTargetCodeValue,
  DealinginfoInputStatusCodeValue,
  FileNameCodeValue,
  PaperIdCodeValue, // No4:スキャナ保存対応 書類ID
  PaperTypeCodeValue,
  IssueDateCodeValue,
  CompanyCodeValue,
  AmountCodeValue,
  RemarksCodeValue,
  UpdaterCodeValue,
  GengoCodeValue,
} from "@/util/data.js";
import { LOGININ_SYSTEM_STATUS_INFO } from "@/util/enum.js";
import Validation, { validation } from "@/util/validation.js";
import ErrorMessage from "@/components/ErrorMessage.vue";
import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
import DateCalandar from "@/components/DateCalandar.vue";
import {
  warekiToYear,
  warekiYearChk,
  yearToWareki,
  verifyMonth,
  isDate,
  warekisikiiChk,
} from "@/util/dateFormat.js";
import { API_STFMFM02C02_SetFilter } from "@/api/Modules/FM02/STFMFM02C02.js";
export default {
  name: "STFMFM02C11FilterCompleteModal",
  components: { ErrorMessage, ErrorMessageCase, DateCalandar }, //No7日付のカレンダー入力対応
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    STFMFM02C11FilterInit: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      showClass: "show",
      hideClass: "hide",
      errors: [], //エラーメッセージ
      isProcessing: false,
      searchTargetCodeList: SEARCH_TARGET_CODE_LIST,
      dealinginfoInputStatusCodeList: DEALINGINFO_INPUT_STATUS_CODE_LIST,
      fileNameCodeList: FILE_NAME_CODE_LIST,
      paperIdCodeList: PAPER_ID_CODE_LIST, // No4:スキャナ保存対応 書類ID
      paperTypeCodeList: PAPER_TYPE_CODE_LIST,
      issueDateCodeList: ISSUE_DATE_CODE_LIST,
      companyCodeList: COMPANY_CODE_LIST,
      amountCodeList: AMOUNT_CODE_LIST,
      remarksCodeList: REMARKS_CODE_LIST,
      updaterCodeList: UPDATER_CODE_LIST,
      yearList: YEAR_LIST,
      searchTargetCodeValue: SearchTargetCodeValue,
      dealinginfoInputStatusCodeValue: DealinginfoInputStatusCodeValue,
      fileNameCodeValue: FileNameCodeValue,
      paperIdCodeValue: PaperIdCodeValue, // No4:スキャナ保存対応 書類ID
      paperTypeCodeValue: PaperTypeCodeValue,
      issueDateCodeValue: IssueDateCodeValue,
      companyCodeValue: CompanyCodeValue,
      amountCodeValue: AmountCodeValue,
      remarksCodeValue: RemarksCodeValue,
      updaterCodeValue: UpdaterCodeValue,
      gengoCodeValue: GengoCodeValue,
      isAmountToInputing: false,
      isAmountFromInputing: false,
      filterViewsDisplay: {}, //画面項目制御
      logininSystemStatus: LOGININ_SYSTEM_STATUS_INFO,
      pageId: "STFMFM02C11",
      searchConditionInfo: {
        pageID: "STFMFM02C11",
        searchTaget: SearchTargetCodeValue.CurrentFolder,
        keyWord: "",
        dealinginfoInputStatus: DealinginfoInputStatusCodeValue.All,
        fileName: FileNameCodeValue.All,
        fileNameInput: "",
        paperID: PaperIdCodeValue.All, // No4:スキャナ保存対応 書類ID
        paperIdInput: "", // No4:スキャナ保存対応 書類ID
        paperType: PaperTypeCodeValue.All,
        paperTypeInput: "",
        issueDate: IssueDateCodeValue.All,
        issueDateGengoFromInput: GengoCodeValue.Reiwa,
        issueDateYearFromInput: "",
        issueDateMonthFromInput: "",
        issueDateDayFromInput: "",
        issueDateGengoToInput: GengoCodeValue.Reiwa,
        issueDateYearToInput: "",
        issueDateMonthToInput: "",
        issueDateDayToInput: "",
        company: CompanyCodeValue.All,
        companyInput: "",
        amount: AmountCodeValue.All,
        amountFromInput: "",
        amountToInput: "",
        remarks: RemarksCodeValue.All,
        remarksInput: "",
        updater: UpdaterCodeValue.All,
        updaterInput: "",
      }, //画面項目設定
      errorInfo: {
        errorFileNameInput: [],
        errorPaperIdInput: [], // No4:スキャナ保存対応 書類ID
        errorPaperTypeInput: [],
        errorIssueDate: [],
        errorCompanyInput: [],
        errorAmount: [],
        errorRemarksInput: [],
        errorUpdaterInput: [],
      },
    };
  },
  created() {
    this.filterViewsDisplay = FILTER_VIEWS_DISPLAY_FLAG_LIST.filter(
      (el) => el.pageId == this.pageId
    )[0];
  },
  watch: {
    isShow: function (newVal) {
      if (newVal) {
        this.handleBodyScrollOnModalStateChange(newVal)
        this.pageId = this.STFMFM02C11FilterInit.pageID;
        this.filterViewsDisplay = FILTER_VIEWS_DISPLAY_FLAG_LIST.filter(
          (el) => el.pageId == this.pageId
        )[0];
        this.searchConditionInfo = _.cloneDeep(this.STFMFM02C11FilterInit);
        this.$nextTick(function () {
          this.$refs.refTitle.innerText =
            this.filterViewsDisplay.DisplayItems.title;
          this.initFocus(); 
        });
      } else {
        this.handleBodyScrollOnModalStateChange(newVal)
      }
    },
  },
  computed: {
    // 名称入力活性制御
    isFileNameInputDisabled() {
      return this.searchConditionInfo.fileName == this.companyCodeValue.All;
    },
    // No4:スキャナ保存対応 書類ID start
    // 書類ID入力活性制御
    isPaperIdInputDisabled() {
      return this.searchConditionInfo.paperID == this.paperIdCodeValue.All;
    }, // No4:スキャナ保存対応 書類ID end
    // 書類種別活性制御
    isPaperTypeInputDisabled() {
      return !(
        this.searchConditionInfo.paperType == this.paperTypeCodeValue.Include ||
        this.searchConditionInfo.paperType == this.paperTypeCodeValue.Exclude
      );
    },
    // 取引年月日(入力_開始_元号)の活性制御
    isissueDateGengoFromSelcetDisabled() {
      return this.searchConditionInfo.issueDate == this.issueDateCodeValue.All;
    },
    // 取引年月日(入力_開始_年)の活性制御
    isIssueDateYearFromInputDisabled() {
      return this.searchConditionInfo.issueDate == this.issueDateCodeValue.All;
    },
    // 取引年月日(入力_開始_月)の活性制御
    isIssueDateMonthFromInputDisabled() {
      return this.searchConditionInfo.issueDate == this.issueDateCodeValue.All;
    },
    // 取引年月日(入力_開始_日)の活性制御
    isIssueDateDayFromInputDisabled() {
      return this.searchConditionInfo.issueDate == this.issueDateCodeValue.All;
    },
    // 取引年月日(入力_開始_日)の表示制御
    isShowIssueDateDayFromInput() {
      return (
        this.searchConditionInfo.issueDate !=
        this.issueDateCodeValue.SpecifiedMonth
      );
    },
    // 取引年月日(入力_開始_元号)の表示制御
    isShowissueDateGengoToInput() {
      return (
        this.searchConditionInfo.issueDate == this.issueDateCodeValue.DuringDate
      );
    },
    // 取引先入力活性制御
    isCompanyInputDisabled() {
      return (
        this.searchConditionInfo.company == this.companyCodeValue.All ||
        this.searchConditionInfo.company == this.companyCodeValue.NotEntered
      );
    },
    // 取引金額入力活性制御
    isAmountFromInputDisabled() {
      return this.searchConditionInfo.amount == this.amountCodeValue.All;
    },
    // 取引金額(入力_開始)表示制御
    isShowAmountToInput() {
      return (
        this.searchConditionInfo.amount == this.amountCodeValue.DuringAmount
      );
    },
    // 備考入力活性制御
    isRemarksInputDisabled() {
      return (
        this.searchConditionInfo.remarks == this.remarksCodeValue.All ||
        this.searchConditionInfo.remarks == this.remarksCodeValue.NotEntered
      );
    },
    // 保存者入力活性制御
    isUpdaterInputDisabled() {
      return this.searchConditionInfo.updater == this.updaterCodeValue.All;
    },
  },
  methods: {
    ...mapMutations("businessModule", ["processDialogue","handleBodyScrollOnModalStateChange"]),
    onblur(e) {
      if (!e) return;
      e.preventDefault();
      // this.initFocus();
    },

    // リセット
    handleReset(saveFlg) {
      this.errors = [];

      //画面項目エリア
      this.searchConditionInfo = {
        pageID: this.pageId,
        searchTaget: SearchTargetCodeValue.CurrentFolder,
        keyWord: "",
        dealinginfoInputStatus: DealinginfoInputStatusCodeValue.All,
        fileName: FileNameCodeValue.All,
        fileNameInput: "",
        paperID: PaperIdCodeValue.All, // No4:スキャナ保存対応 書類ID
        paperIdInput: "", // No4:スキャナ保存対応 書類ID
        paperType: PaperTypeCodeValue.All,
        paperTypeInput: "",
        issueDate: IssueDateCodeValue.All,
        issueDateGengoFromInput: this.gengoCodeValue.Reiwa,
        issueDateYearFromInput: "",
        issueDateMonthFromInput: "",
        issueDateDayFromInput: "",
        issueDateGengoToInput: this.gengoCodeValue.Reiwa,
        issueDateYearToInput: "",
        issueDateMonthToInput: "",
        issueDateDayToInput: "",
        company: CompanyCodeValue.All,
        companyInput: "",
        amount: AmountCodeValue.All,
        amountFromInput: "",
        amountToInput: "",
        remarks: RemarksCodeValue.All,
        remarksInput: "",
        updater: UpdaterCodeValue.All,
        updaterInput: "",
      };
      //画面項目エリア
      this.errorsClear();
      if (saveFlg) {
        this.saveFilter(this.searchConditionInfo);
      }
    },

    //エラーメッセージクリア
    errorsClear() {
      this.errors = [];
      this.errorInfo.errorFileNameInput = [];
      this.errorInfo.errorPaperIdInput = []; // No4:スキャナ保存対応 書類ID
      this.errorInfo.errorPaperTypeInput = [];
      this.errorInfo.errorIssueDate = [];
      this.errorInfo.errorCompanyInput = [];
      this.errorInfo.errorAmount = [];
      this.errorInfo.errorRemarksInput = [];
      this.errorInfo.errorUpdaterInput = [];
    },

    // **********************************************
    // * ダイアログで検索が選択された時の処理
    // **********************************************
    SearchBtn() {
      this.errorsClear();
      if (!this.checkInput()) {
        var scrollPosition = 0;
        // No4:スキャナ保存対応 書類ID
        if (
          this.errorInfo.errorFileNameInput.length == 0 &&
          this.errorInfo.errorPaperIdInput.length == 0 &&
          this.errorInfo.errorPaperTypeInput.length == 0
        ) {
          scrollPosition = this.$refs.refScrollDiv.scrollHeight;
        }
        this.$nextTick(function () {
          this.$refs.refScrollDiv.scrollTop = scrollPosition;
        });

        return;
      }

      var paraFilter = _.cloneDeep(this.searchConditionInfo);

      this.processDialogue(true);
      this.isProcessing = true;
      this.saveFilter(paraFilter)
        .then((result) => {
          if (result == "") {
            this.isProcessing = false;
            this.$emit("filterSTFMFM02C11");
          }
        })
        .catch((result) => {
          this.setErrMsg(result.errorCD, result.errorParaList);
          this.isProcessing = false;
          this.processDialogue(false);
          return;
        });
    },
    // **********************************************
    // * ダイアログでキャンセルが選択された時の処理
    // **********************************************
    CancelBtn() {
      this.handleReset(false);
      this.$emit("canceFilterSTFMFM02C11");
    },
    // * 初期フォーカス設定
    // **********************************************
    initFocus() {
      if (this.filterViewsDisplay.DisplayFlags.searchTaget) {
        this.$refs.refSearchTarget.focus();
      } else {
        this.$refs.refSearchKeyWord.focus();
      }
    },

    // **********************************************
    // * フィルタ_DB保存
    // **********************************************
    saveFilter(filterInfo) {
      this.errors = [];
      var paraFilter = _.cloneDeep(filterInfo);

      let params = {
        sTFMFM02C02Filter: paraFilter,
      };
      return new Promise((resolve, reject) => {
        // フィルター条件保存処理
        API_STFMFM02C02_SetFilter(params).then((response) => {
          // 正常終了の場合
          if (_.eq(response.result, "0000")) {
            return resolve("");
          } else {
            return reject(response);
          }
        });
      });
    },
    /**
     * ```ts
     * 数値と"-"キーのみを受け付ける
     * "-"は以下の場合受け付けない
     *  1.入力後の文字列が整数ではない
     * ```
     * @param {キーイベント} e
     */
    amountOnKeyPress(e, ref, amountInput) {
      var selectStart = ref.selectionStart;
      var selectEnd = ref.selectionEnd;
      // 0～9又は"-"の場合
      if ((e.charCode >= 48 && e.charCode <= 57) || e.charCode == 45) {
        var amount = amountInput;
        // カーソルのstart,end位置で文字列を分割
        var val1 = amount.substring(0, selectStart);
        var val2 = amount.substring(selectStart, selectEnd);
        var val3 = amount.substring(selectEnd, amount.length);

        // カーソルのstart前の文字列+入力キーコード対応の文字列+カーソルのend後の文字列が"-"又は整数かの判定
        amount = val1 + String.fromCharCode(e.charCode) + val3;
        if (amount == "-" || Validation.isInteger(amount)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    /**
     * 金額入力項目のフォーカスイン
     */
    amountFromInputFocusin() {
      this.isAmountFromInputing = true;
      this.searchConditionInfo.amountFromInput =
        this.searchConditionInfo.amountFromInput.replace(/,/g, "");
    },
    /**
     * 金額入力項目のフォーカスアウト
     */
    amountFromInputFocusOut() {
      this.isAmountFromInputing = false;
      var amount = this.searchConditionInfo.amountFromInput;
      if (amount !== "") {
        if (Validation.isInteger(amount)) {
          this.searchConditionInfo.amountFromInput =
            Number(amount).toLocaleString();
        }
      }
    },
    /**
     * 金額入力項目のフォーカスイン
     */
    amountToInputFocusin() {
      this.isAmountToInputing = true;
      this.searchConditionInfo.amountToInput =
        this.searchConditionInfo.amountToInput.replace(/,/g, "");
    },
    /**
     * 金額入力項目のフォーカスアウト
     */
    amountToInputFocusOut() {
      this.isAmountToInputing = false;
      var amount = this.searchConditionInfo.amountToInput;
      if (amount !== "") {
        if (Validation.isInteger(amount)) {
          this.searchConditionInfo.amountToInput =
            Number(amount).toLocaleString();
        }
      }
    },
    // 名称プルダウン変更
    handleFileNameChange(e) {
      if (this.isFileNameInputDisabled) {
        this.searchConditionInfo.fileNameInput = "";
      }
    },
    // No4:スキャナ保存対応 書類ID start
    // 書類IDプルダウン変更
    handlePaperIdChange(e) {
      if (this.isPaperIdInputDisabled) {
        this.searchConditionInfo.paperIdInput = "";
      }
    }, // No4:スキャナ保存対応 書類ID end
    // 書類種別プルダウン変更
    handlePaperTypeChange(e) {
      if (this.isPaperTypeInputDisabled) {
        this.searchConditionInfo.paperTypeInput = "";
      }
    },
    // 取引年月日プルダウン変更
    handleIssueDateChange(e) {
      this.searchConditionInfo.issueDateGengoFromInput =
        this.gengoCodeValue.Reiwa;
      this.searchConditionInfo.issueDateYearFromInput = "";
      this.searchConditionInfo.issueDateMonthFromInput = "";
      this.searchConditionInfo.issueDateDayFromInput = "";
      this.searchConditionInfo.issueDateGengoToInput =
        this.gengoCodeValue.Reiwa;
      this.searchConditionInfo.issueDateYearToInput = "";
      this.searchConditionInfo.issueDateMonthToInput = "";
      this.searchConditionInfo.issueDateDayToInput = "";
    },
    // 取引年月日プルダウン変更
    handleIssueDateGengoFromChange(e) {
      this.searchConditionInfo.issueDateYearFromInput = "";
      this.searchConditionInfo.issueDateMonthFromInput = "";
      this.searchConditionInfo.issueDateDayFromInput = "";
    },
    // 取引年月日プルダウン変更
    handleIssueDateGengToChange(e) {
      this.searchConditionInfo.issueDateYearToInput = "";
      this.searchConditionInfo.issueDateMonthToInput = "";
      this.searchConditionInfo.issueDateDayToInput = "";
    },
    // 取引金額プルダウン変更
    handleAmountChange(e) {
      this.searchConditionInfo.amountFromInput = "";
      this.searchConditionInfo.amountToInput = "";
    },
    // 取引先プルダウン変更
    handleCompanyChange(e) {
      if (this.isCompanyInputDisabled) {
        this.searchConditionInfo.companyInput = "";
      }
    },
    // 備考プルダウン変更
    handleRemarksChange(e) {
      if (this.isRemarksInputDisabled) {
        this.searchConditionInfo.remarksInput = "";
      }
    },
    // 保存者プルダウン変更
    handleUpdaterChange(e) {
      if (this.isUpdaterInputDisabled) {
        this.searchConditionInfo.updaterInput = "";
      }
    },
    /**
     * エラー内容セット
     * @param {エラーコード} errCd
     * @param {エラーコードの埋め込み文字} param
     */
    setErrMsg(errCd, param) {
      // PDF変換エラーがある状態で別のエラーが来たら別のエラーを優先
      if (this.errors.length == 0) {
        this.errors.push(
          Common.createError(errCd, Common.getMessage(errCd, param))
        );
      }
    },
    // 入力チェック
    checkInput() {
      this.checkFileName();
      this.checkPaperId(); // No4:スキャナ保存対応 書類ID
      this.checkPaperType();
      this.checkIssueDate();
      this.checkCompany();
      this.checkAmount();
      this.checkRemarks();
      this.checkUpdater();
      if (this.errors.length > 0) {
        this.$refs.refScrollDiv.scroll({ top: 0, behavior: "smooth" });
        return false;
      } else {
        return true;
      }
    },

    // 名称チェック
    checkFileName() {
      if (!this.isFileNameInputDisabled) {
        if (!Validation.isRequired(this.searchConditionInfo.fileNameInput)) {
          // エラー表示
          var errCd = "MTCL1001";
          var errPara = ["名称"];
          this.errorInfo.errorFileNameInput.push(
            Common.createError(errCd, Common.getMessage(errCd, errPara))
          );
          this.setErrMsg("MTCL1119", []);
          return false;
        }
      }
      return true;
    },
    // No4:スキャナ保存対応 書類ID start
    // 書類IDチェック
    checkPaperId() {
      if (!this.isPaperIdInputDisabled) {
        if (!Validation.isRequired(this.searchConditionInfo.paperIdInput)) {
          // エラー表示
          var errCd = "MTCL1001";
          var errPara = ["書類ID"];
          this.errorInfo.errorPaperIdInput.push(
            Common.createError(errCd, Common.getMessage(errCd, errPara))
          );
          this.setErrMsg("MTCL1119", []);
          return false;
        }
      }
      return true;
    }, // No4:スキャナ保存対応 書類ID end
    // 書類種別チェック
    checkPaperType() {
      if (!this.isPaperTypeInputDisabled) {
        if (!Validation.isRequired(this.searchConditionInfo.paperTypeInput)) {
          // エラー表示
          var errCd = "MTCL1001";
          var errPara = ["書類種別"];
          this.errorInfo.errorPaperTypeInput.push(
            Common.createError(errCd, Common.getMessage(errCd, errPara))
          );
          this.setErrMsg("MTCL1119", []);
          return false;
        }
      }
      return true;
    },
    // 取引先チェック
    checkCompany() {
      if (!this.isCompanyInputDisabled) {
        if (!Validation.isRequired(this.searchConditionInfo.companyInput)) {
          // エラー表示
          var errCd = "MTCL1001";
          var errPara = ["取引先"];
          this.errorInfo.errorCompanyInput.push(
            Common.createError(errCd, Common.getMessage(errCd, errPara))
          );
          this.setErrMsg("MTCL1119", []);
          return false;
        }
      }
      return true;
    },
    // 備考チェック
    checkRemarks() {
      if (!this.isRemarksInputDisabled) {
        if (!Validation.isRequired(this.searchConditionInfo.remarksInput)) {
          // エラー表示
          var errCd = "MTCL1001";
          var errPara = ["備考"];
          this.errorInfo.errorRemarksInput.push(
            Common.createError(errCd, Common.getMessage(errCd, errPara))
          );
          this.setErrMsg("MTCL1119", []);
          return false;
        }
      }
      return true;
    },
    // 保存者チェック
    checkUpdater() {
      if (!this.isUpdaterInputDisabled) {
        if (!Validation.isRequired(this.searchConditionInfo.updaterInput)) {
          // エラー表示
          var errCd = "MTCL1001";
          var errPara = ["保存者"];
          this.errorInfo.errorUpdaterInput.push(
            Common.createError(errCd, Common.getMessage(errCd, errPara))
          );
          this.setErrMsg("MTCL1119", []);
          return false;
        }
      }
      return true;
    },
    // 取引年月日チェック
    checkIssueDate() {
      var gengoFrom = this.searchConditionInfo.issueDateGengoFromInput;
      var yearFrom = this.searchConditionInfo.issueDateYearFromInput;
      var monthFrom = this.searchConditionInfo.issueDateMonthFromInput;
      var dayFrom = this.searchConditionInfo.issueDateDayFromInput;
      var gengoTo = this.searchConditionInfo.issueDateGengoToInput;
      var yearTo = this.searchConditionInfo.issueDateYearToInput;
      var monthTo = this.searchConditionInfo.issueDateMonthToInput;
      var dayTo = this.searchConditionInfo.issueDateDayToInput;

      var errCd = "";
      var errPara = ["取引年月日"];

      if (this.isissueDateGengoFromSelcetDisabled) {
        return true;
      }

      // 必須チェック
      if (
        !Validation.isRequired(yearFrom) ||
        !Validation.isRequired(monthFrom)
      ) {
        errCd = "MTCL1001";
        errPara = ["取引年月日"];
      } else if (this.isShowIssueDateDayFromInput) {
        if (!Validation.isRequired(dayFrom)) {
          errCd = "MTCL1001";
          errPara = ["取引年月日"];
        }
      } else if (this.isShowissueDateGengoToInput) {
        if (
          !Validation.isRequired(yearTo) ||
          !Validation.isRequired(monthTo) ||
          !Validation.isRequired(dayTo)
        ) {
          errCd = "MTCL1001";
          errPara = ["取引年月日"];
        }
      }
      if (errCd != "") {
        this.errorInfo.errorIssueDate.push(
          Common.createError(errCd, Common.getMessage(errCd, errPara))
        );
        this.setErrMsg("MTCL1119", []);
        return false;
      }
      // 数値チェック
      if (!Validation.isNumeric(yearFrom) || !Validation.isNumeric(monthFrom)) {
        errCd = "MTFM1110";
      } else if (this.isShowIssueDateDayFromInput) {
        if (!Validation.isNumeric(dayFrom)) {
          errCd = "MTFM1110";
        }
      } else if (this.isShowissueDateGengoToInput) {
        if (
          !Validation.isNumeric(yearTo) ||
          !Validation.isNumeric(monthTo) ||
          !Validation.isNumeric(dayTo)
        ) {
          errCd = "MTFM1110";
        }
      }
      if (errCd != "") {
        this.errorInfo.errorIssueDate.push(
          Common.createError(errCd, Common.getMessage(errCd, errPara))
        );
        this.setErrMsg("MTCL1119", []);
        return false;
      }
      var dateFrom = "";
      var dateTo = "";
      // 日付妥当性チェック
      if (!this.isShowIssueDateDayFromInput) {
        if (gengoFrom == this.gengoCodeValue.Reiwa) {
          dayFrom = "1";
        } else {
          dayFrom = "0";
        }
      }
      if (this.checkIssudateInvalid(gengoFrom, yearFrom, monthFrom, dayFrom)) {
        dateFrom =
          String(warekiToYear(gengoFrom, yearFrom)).padStart(4, "0") +
          monthFrom.padStart(2, "0") +
          dayFrom.padStart(2, "0");
      } else {
        errCd = "MTFM1100";
        this.errorInfo.errorIssueDate.push(
          Common.createError(errCd, Common.getMessage(errCd, errPara))
        );
        this.setErrMsg("MTCL1119", []);
        return false;
      }

      if (!this.isShowissueDateGengoToInput) {
        return true;
      }

      if (this.checkIssudateInvalid(gengoTo, yearTo, monthTo, dayTo)) {
        dateTo =
          String(warekiToYear(gengoTo, yearTo)).padStart(4, "0") +
          monthTo.padStart(2, "0") +
          dayTo.padStart(2, "0");
        if (dateFrom > dateTo) {
          errCd = "MTCL1046";
          errPara = ["指定期間"];
        }
      } else {
        errCd = "MTFM1100";
      }
      if (errCd != "") {
        this.errorInfo.errorIssueDate.push(
          Common.createError(errCd, Common.getMessage(errCd, errPara))
        );
        this.setErrMsg("MTCL1119", []);
        return false;
      } else {
        return true;
      }
    },
    // 取引金額チェック
    checkAmount() {
      var errCd = "";
      var errPara = ["取引金額"];
      var amountFrom = this.searchConditionInfo.amountFromInput.replace(
        /,/g,
        ""
      );
      // checkAmountfrom
      if (!this.isAmountFromInputDisabled) {
        if (!Validation.isRequired(this.searchConditionInfo.amountFromInput)) {
          errCd = "MTCL1001";
        } else if (!Validation.isInteger(amountFrom)) {
          errCd = "MTCL1006";
        }
        if (errCd != "") {
          this.errorInfo.errorAmount.push(
            Common.createError(errCd, Common.getMessage(errCd, errPara))
          );
          this.setErrMsg("MTCL1119", []);
          return false;
        }
      }
      // checkAmountTo
      var amountTo = this.searchConditionInfo.amountToInput.replace(/,/g, "");
      if (this.isShowAmountToInput) {
        if (!Validation.isRequired(this.searchConditionInfo.amountToInput)) {
          errCd = "MTCL1001";
        } else if (!Validation.isInteger(amountTo)) {
          errCd = "MTCL1006";
        } else {
          // 範囲チェック
          if (Number(amountFrom) > Number(amountTo)) {
            errCd = "MTFM1370";
          }
        }
        if (errCd != "") {
          this.errorInfo.errorAmount.push(
            Common.createError(errCd, Common.getMessage(errCd, errPara))
          );
          this.setErrMsg("MTCL1119", []);
          return false;
        }
      }
      return true;
    },
    checkIssudateInvalid(wreki, yearVal, monthVal, dayVal) {
      var bRet = false;
      var msg = Validation.checkFilterDate(
        "1",
        wreki,
        yearVal,
        monthVal,
        dayVal,
        "取引年月日"
      );
      if (msg == "") {
        // 和暦有効判定
        bRet = this.warekiCheck(
          Number(wreki),
          Number(yearVal),
          Number(monthVal),
          Number(dayVal)
        );
      } else {
        bRet = false;
      }
      return bRet;
    },
    /**
     * 和暦有効判定
     * @param {*} reki 和暦
     * @param {*} year 年
     * @param {*} month 月
     * @param {*} day 日
     * @returns チェック結果 true  : チェックOK / false : チェックNG
     */
    warekiCheck(reki, year, month, day) {
      if (isNaN(reki) || isNaN(year) || isNaN(month) || isNaN(day))
        return false;

      if (reki == 1) {
        //1:平成　1年1月8日～31年４月30日まで
        //平成元年チェック
        if (year == 1) {
          if (month == 1) {
            if (day < 8) return false;
          }
        }

        //令和元年以降チェック
        if (year == 31) {
          if (month >= 5) {
            if (day >= 1) return false;
          }
        }

        if (year > 31 || year < 1) {
          return false;
        }
      }
      if (reki == 0) {
        //0:令和　元年5月1日から
        //令和元年チェック
        if (year == 1 && month <= 4) {
          return false; // 令和
        }

        if (year < 1) {
          return false;
        }
      }
      return true;
    },
    /**
     * null,empty判定
     * @param {判定対象} val
     */
    isNullOrEmpty(val) {
      if (val === null || val === "") {
        return true;
      } else {
        return false;
      }
    },
    // No7日付のカレンダー入力対応
    handleDateChange(
      {
        issueDateNengo,
        issueDateWarekiYear,
        issueDateWarekiMonth,
        issueDateWarekiDay,
      },
      target,
      keys
    ) {
      target[keys[0]] = issueDateNengo
        ? String(
            this.yearList.find((item) => {
              return item.name == issueDateNengo;
            }).code
          )
        : "";
      target[keys[1]] = String(issueDateWarekiYear);
      target[keys[2]] = String(issueDateWarekiMonth);
      if (this.searchConditionInfo.issueDate == "4") {
        target[keys[3]] = "";
      } else {
        target[keys[3]] = String(issueDateWarekiDay);
      }
    },
  },
};
</script>

<style scoped>
* + .frm-unit {
  margin-left: 6px;
  font-size: 1.3rem;
}
.ml-l45px {
  margin-left: 145px;
}
.popup .scroll {
  height: 353px;
  padding-right: 10px;
}
@media (max-width: 768px) {
  .frm-row .date-picker-wrap {
    margin-left: 0;
  }
  .errMsg {
    margin-left: 0;
  }
  .frm-text.w-160px.alignright{
    margin-left: 0;
  }
}
.popup .scroll {
  height: unset;
  overflow: visible;
  padding-right: 10px;
}
</style>
